import { useAppContext } from '../context';
import { IAudioCreation, Status } from '../../@types';
import { useEffect } from 'react';
import { STATUS_REGISTRATION_REQUIREMENT } from '../../utils';

interface Props {
  textToSpeechData: IAudioCreation;
}

export const useTextToSpeechCard = ({ textToSpeechData }: Props) => {
  const { id, status, processedURL: initialProcessedURL } = textToSpeechData || {};

  const initialAudioStatus = status ?? null;
  const initialUrlData = initialProcessedURL ?? null;

  const {
    websocket: { isConnected, sendMessage, textToSpeechTaskMap },
  } = useAppContext();

  const textToSpeechTask = textToSpeechTaskMap.get(id) ?? null;
  const {
    status: taskStatus = null,
    progress: taskProgress = 0,
    data: { processedURL = '' } = {},
  } = textToSpeechTask || {};

  const audioDataStatus = taskStatus || initialAudioStatus;
  const audioUrl = processedURL || initialUrlData;
  const cardProgress = taskProgress;

  useEffect(() => {
    const { registrationRequired } = STATUS_REGISTRATION_REQUIREMENT;
    if (isConnected && registrationRequired.includes(audioDataStatus)) {
      sendMessage({
        event: 'register',
        data: { id },
      });
    }
  }, [isConnected, audioDataStatus, id, sendMessage]);

  return {
    audioDataStatus,
    audioUrl,
    cardProgress,
  };
};
